var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.357 22q-.766 0-1.311-.534a1.73 1.73 0 0 1-.546-1.284V3.818q0-.75.546-1.284Q6.59 2 7.357 2h9.286q.766 0 1.311.534.546.534.546 1.284v16.364q0 .75-.546 1.284-.544.534-1.311.534zm0-2.727v.909h9.286v-.91zm0-1.819h9.286V6.545H7.357zm0-12.727h9.286v-.909H7.357z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.a879bdd6bc87188704486e07aae7e2df.svg";
export { ForwardRef as ReactComponent };